﻿(function ($, document) {
    $(document).on('click', '.js-show-more-pricelines', function (e) {
        e.preventDefault();
        var $item = $(this).closest('.row').siblings('.product-row__additional');
        $item.show();
        $(this).closest('.row').remove();
    });

})(jQuery, document);